import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="app-footer mt-5">
      <div className="container app-footer-shell">
        <div className="row g-4 app-footer-grid">
          <div className="col-md-4">
            <h5 className="app-footer-title">Infinite EduTech</h5>
            <p className="app-footer-text">
              Providing expert guidance to help students choose the right career
              path and achieve their goals.
            </p>
          </div>

          <div className="col-md-4">
            <h5 className="app-footer-title">Quick Links</h5>
            <ul className="list-unstyled app-footer-links mb-0">
              <li>
                <Link to="/" className="app-footer-link text-decoration-none">
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/what-we-do/our-services"
                  className="app-footer-link text-decoration-none"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/who-we-help/students"
                  className="app-footer-link text-decoration-none"
                >
                  Students
                </Link>
              </li>
              <li>
                <Link to="/contact" className="app-footer-link text-decoration-none">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div className="col-md-4">
            <h5 className="app-footer-title">Contact</h5>
            <p className="app-footer-contact-item mb-2">Email: info@infiniteedutech.com</p>
            <p className="app-footer-contact-item mb-2">Phone: +91 9100460343</p>
            <p className="app-footer-contact-item mb-0">
              Address: Raj Vihar Circle, Kurnool, Andhra Pradesh, 518001
            </p>
          </div>
        </div>

        <hr className="app-footer-divider" />

        <div className="text-center app-footer-bottom">
          <p className="mb-0 app-footer-copy">
            &copy; {new Date().getFullYear()} Infinite EduTech. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
